import { render, staticRenderFns } from "./regional.vue?vue&type=template&id=7840728c&scoped=true"
import script from "./regional.vue?vue&type=script&lang=js"
export * from "./regional.vue?vue&type=script&lang=js"
import style0 from "./regional.vue?vue&type=style&index=0&id=7840728c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7840728c",
  null
  
)

export default component.exports